// extracted by mini-css-extract-plugin
export default {"input":"input--nwvua","textarea":"textarea--ONGYE","label":"label--dhjSm"};